<template>
    <div class="row">
        <div class="col-sm-12 row-no-padding text-left text">
            <div class="row align-items-start">
                <div class="col-12 col-xl-7 article-images">
                    <a
                        v-for="(image, id) in article.images"
                        :key="id"
                        class="article-image-link"
                        :href="`${base}${image}`"
                        target="_blank"
                        rel="noopener"
                        @click="openImage($event, id)">
                        <img
                            class="article-image"
                            :src="`${base}${image}`"
                            :alt="article.title" />
                    </a>
                </div>
                <div class="col-12 col-xl-5 article-text">
                    <h3 class="m-t-lg-5">{{article.title}}</h3>
                    <p v-if="article.description"><i>{{ article.description }}</i></p>
                    <div v-html="article.long_description"></div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-lg-6 text-left">&nbsp;</div>
        <div class="col-sm-12 col-lg-6 text-right pad-top">
            <a href="#app" class="back2top">Back to top</a>
        </div>
        <div class="col-sm-12 col-lg-6 pad-top text-left">
            &nbsp;
        </div>
        <mg-lightbox
            v-model:index="openIndex"
            :images="article.images.map(image => `${base}${image}`)"
            :alt="article.title" />
    </div>
</template>

<script>
import MgLightbox from './mg-lightbox.vue';

export default {
    components: { MgLightbox },
    data() {
        return { openIndex: null };
    },
    watch: {
        '$route.params.id'() {
            this.openIndex = null;
        }
    },
    methods: {
        openImage(event, index) {
            // A modified click still means "open in a new tab", which the link does.
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.openIndex = index;
        }
    },
    computed: {
        article() {
            console.log("getting article", this.$route.params.id, this.$store.state.articles);
            return this.$store.state.articles.find(a => String(a.id) === this.$route.params.id);
        },
        base() {
            return this.$store.state.baseStorageUri;
        }
    },
    mounted() {
        const thisArticle = this.$store.state.articles.find(a => String(a.id) === this.$route.params.id);
        if (!thisArticle) {
            this.$router.push('/not-found');
        }
        console.log("Component mounted");
    }
}
</script>


<style lang="scss" scoped>
.article-images {
    display: flex;
    flex-direction: column;
    // The default stretch would widen a height-capped portrait out of shape.
    align-items: flex-start;
}
.article-text {
    // Keeps lines under ~70 characters on wide screens, where 5/12 runs past 80.
    max-width: 31rem;
}
.article-image-link {
    max-width: 100%;
    margin-bottom: 20px;
    cursor: zoom-in;
}
// Stacked, the order is first image, text, then the rest: the text alone
// would otherwise open the page, or sit below every image of the work.
// display: contents lets the images take turns with the text in the row.
@media (max-width: 1199.98px) {
    .article-images {
        display: contents;
    }
    .article-image-link {
        flex: 0 0 100%;
        padding: 0 15px;
        order: 2;
        &:first-child {
            order: 0;
        }
    }
    .article-text {
        order: 1;
    }
}
.article-image {
    display: block;
    max-width: 100%;
    max-height: 85vh;
}
h3 {
    margin-bottom: 0px;
    line-height: 13px;
    margin-top: 10px;
}
.pad-top {
    padding-top: 50px;
    padding-bottom: 50px;
}
.text {
    line-height: 18px;
}
</style>
